import React, {useEffect, useState} from "react";
import "./UIMessageMention.scss";
import {expDomain, expEmail, expURL} from "../ChatConstants";

const UIMessageMention = (props) => {
  const { msgObj, onClickMention } = props;
  const [mentionDetails, setMentionDetails] = useState();
  const [messageText, setMessageText] = useState();

  // useEffect(()=>{
  //   console.log("Message: ",msgObj) 
  // }, [])

  const handleClickMention = (item) => {
    if (typeof onClickMention === "function") {
      let userId = item?.user?.mention?.userId;
      onClickMention(userId);
    }
  };

  useEffect(() => {
    let mentionProperty = msgObj?.mentionProperty;
    let mentionDetails = mentionProperty?.mentionDetails;
    setMentionDetails(mentionDetails);

    let messageText =  mentionProperty?.messageText;
    setMessageText(messageText.split(" "));
  }, [msgObj]);

  return (
    <div className="msg-mention-wrapper">
      {/* { messageText?.map((item) => {
        let isMention = item.match(expMention);
        if ( isMention?.length > 0 ) {
          let mentionDetailsUser =  mentionDetails.filter((mention)=>{
            return mention.text === item
          })[0]
          return (
            <span
              className="msg-mention"
              onClick={handleClickMention.bind(this, mentionDetailsUser)}
            >
              {item}
            </span>
          );
        } else {
          let isHaveUrl = item.match(expURL);
          if (isHaveUrl?.length > 0) {
            return (item) => {
              let isUrl = item.match(expURL);
              let isEmail = item.match(expEmail);
              if (isUrl?.length > 0) {
                let domain = item.match(expDomain);
                return (
                  <span>
                    <a href={item} target="_blank">
                      {domain?.length > 0 ? `${domain[0]}` : `${item}`}
                    </a>{" "}
                  </span>
                );
              } else if (isEmail?.length > 0) {
                return <span className="msg-email">{item}</span>;
              } else {
                return <span> {item} </span>;
              }
            }
          } else {
            let isEmail = item.match(expEmail);
            if (isEmail?.length > 0) {
              return (item) => {
                let isEmail = item.match(expEmail);
                if (isEmail?.length > 0) {
                  return <span className="msg-email">{item}</span>;
                } else {
                  return <span> {item} </span>;
                }
              };
            } else {
              return " "+item+" ";
            }
          }
        }
      })} */}

      {mentionDetails?.map((item) => {
        if (item?.type === "text") {
          let text = item?.text;
          let isHaveUrl = text.match(expURL);
          if (isHaveUrl?.length > 0) {
            let textList = item?.text.split(" ");
            return textList?.map((txt) => {
              let isUrl = txt.match(expURL);
              let isEmail = txt.match(expEmail);
              if (isUrl?.length > 0) {
                let domain = txt.match(expDomain);
                return (
                  <span>
                    <a href={txt} target="_blank">
                      {domain?.length > 0 ? `${domain[0]}` : `${txt}`}
                    </a>{" "}
                  </span>
                );
              } else if (isEmail?.length > 0) {
                return <span className="msg-email">{txt}</span>;
              } else {
                return <span>{txt} </span>;
              }
            });
          } else {
            let isEmail = text.match(expEmail);
            if (isEmail?.length > 0) {
              let textList = text.split(" ");
              return textList?.map((txt) => {
                let isEmail = txt.match(expEmail);
                if (isEmail?.length > 0) {
                  return <span className="msg-email">{txt}</span>;
                } else {
                  return <span>{txt} </span>;
                }
              });
            } else {
              return text;
            }
          }
        } else if (item?.type === "mention") {
          return (
            <span
              className="msg-mention"
              onClick={handleClickMention.bind(this, item)}
            >
              {item?.text}
            </span>
          );
        }
        return "";
      })}

    </div>
  );
};

export default UIMessageMention;
